import React from "react";
import {Link} from "react-router-dom";
import {Button} from "@material-tailwind/react";

function MobileNextButton({link, enabled, buttonText, disabledText}) {
    return (
        <div className="lg:hidden mt-6 sm:mt-8">
            {enabled ? (
                <Link to={link}>
                    <Button
                        color="blue"
                        size="lg"
                        fullWidth
                        className="py-3 sm:py-4 text-base sm:text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                    >
                        {buttonText}
                    </Button>
                </Link>
            ) : (
                <Button
                    color="gray"
                    size="lg"
                    fullWidth
                    disabled
                    className="py-3 sm:py-4 text-base sm:text-lg"
                >
                    {disabledText}
                </Button>
            )}
        </div>
    );
}

export default MobileNextButton;

